export enum PlanInterval {
  MONTHLY = 'monthly',
  SEMI_ANNUALLY = 'semi-annually',
  ANNUALLY = 'annually',
}
